<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page MNG_SalesReport002
 * @created at      :   2024/10/08
 * @created by      :   ANS352
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapActions, mapMutations, mapState } from 'vuex';
import store from '@/store';
import MNG_SalesReport002_store from '@/views/move/mng_salesreport/MNG_SalesReport002/store';
import MNG_WorkReport002_store from '@/views/move/mng_workreport/MNG_WorkReport002/store';
import PopupMST001 from '@/views/popupSearch/PopupMST001/store';
import PopupMST002 from '@/views/popupSearch/PopupMST002/store';
import PopupMST005Store from '@/views/popupSearch/PopupMST005/store';
import PopupSystem001Store from '@/views/popupSearch/PopupSystem001/store';
/**
 * Import template
 */
import template from './template.html';
import './style.scss';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';
import helpers from '@/utils/helpers';
import repository from './repository';
/**
 * Define component chat for show page chat
 */
var MNG_SalesReport002 = {
    template: template,
    props: {
        typeSelected: {
            type: Number,
            default: 1
        },
        mode: {
            type: Number,
            default: 0
        },
        checkTab: {
            type: Number,
            default: 0
        },
        tabId: {
            type: [String, Number],
            default: 0
        },
        arrayItem: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['hide-detail-tab'],
    components: {},
    beforeCreate() {
        if (!store.hasModule('MNG_SalesReport002')) {
            store.registerModule('MNG_SalesReport002', MNG_SalesReport002_store);
        }
        if (!store.hasModule('MNG_WorkReport002')) {
            store.registerModule('MNG_WorkReport002', MNG_WorkReport002_store);
        }
        if (!store.hasModule('PopupMST001')) {
            store.registerModule('PopupMST001', PopupMST001);
        }
        if (!store.hasModule('PopupMST002')) {
            store.registerModule('PopupMST002', PopupMST002);
        }
        if (!store.hasModule('PopupMST005')) {
            store.registerModule('PopupMST005', PopupMST005Store);
        }
        if (!store.hasModule('PopupSystem001')) {
            store.registerModule('PopupSystem001', PopupSystem001Store);
        }
    },
    created() {
        if (this.tabId) {
            this.localData = this.listPlace.find((item) => item.id == this.tabId);
            return;
        }
        this.setHeader(this.header);
        this.setScreenId(this.screenId);
        this.applyLoginCompanyFilter();
        this.applyArrayItem(this.arrayItem);
    },
    mounted() {
        if (this.$route.path === '/MNG_SalesReport001') {
            this.setHeader(this.header);
        }
        if (!this.tabId) {
            this.$nextTick(() => {
                this.focusFirstInvalidField();
            });
        }
    },
    unmounted() {},
    data() {
        return {
            screenId: 'MNG_SalesReport002',
            isShowWorkReport003: false,
            sort: {
                start_date: '',
                name_person: '',
                notes: ''
            },
            reporting_filename: '',
            localData: null
        };
    },
    watch: {
        typeSelected(newVal) {
            this.realData.type = newVal;
            this.changeType();
        },
        arrayItem: {
            deep: true,
            handler(newVal) {
                if (this.tabId) return;
                this.applyArrayItem(newVal);
            }
        },
        canSubmit() {
            if (this.tabId) return;
            this.setHeader(this.header);
        }
    },
    computed: {
        ...mapState('app', ['user']),
        ...mapState('MNG_SalesReport002', ['optionGroup', 'data', 'paginationData']),
        ...mapState('MNG_WorkReport002', { listPlace: (state) => state.data.sites }),
        isEditMode() {
            return Number(this.mode) === 1;
        },
        loginCompanyCd() {
            const companyCd = Number(this.user?.company_cd);
            return Number.isNaN(companyCd) ? null : companyCd;
        },
        isCompanyEditable() {
            return this.loginCompanyCd === null || this.loginCompanyCd === 99;
        },
        canSubmit() {
            const companyCd = String(this.realData?.company_cd || '').trim();
            const mdcd = Number(this.realData?.mdcd || 0);
            const clientCd = this.realData?.client_cd || '';
            const branchCd = String(this.realData?.branch_cd || '').trim();
            return Boolean(companyCd) && mdcd > 0 && Boolean(clientCd) && Boolean(branchCd) && !this.hasInvalidScheduleRows();
        },
        header() {
            const data = {
                title: '取引先別営業報告一覧',
                topButtons: [
                    {
                        title: {
                            text: '登録/更新',
                            class: {},
                            style: {}
                        },
                        icon: {
                            name: 'fa-solid fa-plus-circle',
                            class: {},
                            style: {}
                        },
                        isShow: true,
                        isDisabled: !this.canSubmit,
                        onClick: () => {
                            this.submit();
                        }
                    },
                    {
                        title: {
                            text: '戻る',
                            class: {},
                            style: {}
                        },
                        icon: {
                            name: 'fa-solid fa-arrow-left',
                            class: {},
                            style: {}
                        },
                        isShow: true,
                        isDisabled: false,
                        onClick: () => {
                            this.handleBack();
                        }
                    }
                ]
            };
            return data;
        },
        realData() {
            // return this.tabId ? this.localData : this.realData;
            return this.tabId ? this.localData : this.data;
        }
    },
    methods: {
        ...mapMutations('app', [
            'showHeaderError',
            'setScreenId',
            'setHeader',
            'setNotification',
            'showModalMessage',
            'hideModalMessage',
            'hideHeaderError'
        ]),
        ...mapActions('PopupMST001', ['searchMst001Info']),
        ...mapActions('PopupMST002', ['searchMst002Info']),
        ...mapActions('PopupMST005', ['searchAreaInfo']),
        ...mapActions('PopupSystem001', ['searchSystemInfo']),
        ...mapMutations('MNG_SalesReport002', ['resetFormData']),
        ...mapActions('MNG_WorkReport002', ['searchPastSalesReport']),
        resetDetailBody() {
            this.realData.work_report_id = 0;
            this.realData.tab_no = 1;
            this.realData.visit_date = '';
            this.realData.report_date = '';
            this.realData.report_items_contents1 = '';
            this.realData.reporting_filename = '';
            this.realData.reporting_file = '';
            this.realData.schedules = [
                { staff_detail_no: 0, no: '', start_date: '', name_person: '', filename: '', file_path: '', file: '', notes: '' }
            ];
            this.realData.visit_reports = [];
            this.paginationData.pageNo = 1;
            this.paginationData.totalRows = 0;
            this.paginationData.msgNoData = '該当するデータが存在しません。';
        },
        clearBranchInfo() {
            this.realData.branch_cd = '';
            this.realData.branch_nm = '';
        },
        clearDepartmentInfo() {
            this.realData.md_name = '';
            this.realData.mdcd = 0;
        },
        tryLoadByCurrentKey() {
            const companyCd = String(this.realData.company_cd || '').trim();
            const clientCd = String(this.realData.client_cd || '').trim();
            const branchCd = String(this.realData.branch_cd || '').trim();

            if (!companyCd || !this.isValidRouteClientCd(clientCd) || !branchCd) {
                this.resetDetailBody();
                return;
            }

            this.referByRouteId(clientCd, companyCd);
        },
        isValidRouteClientCd(value) {
            if (value === null || value === undefined || value === '') return false;
            const clientCd = Number(value);
            return !Number.isNaN(clientCd) && clientCd > 0;
        },
        applyLoginCompanyFilter() {
            if (this.isCompanyEditable || this.loginCompanyCd === null) return;
            this.realData.company_cd = this.loginCompanyCd;
        },
        handleBack() {
            if (this.$route?.name === 'MNG_SalesReport001' || this.$route?.path === '/MNG_SalesReport001') {
                this.$emit('hide-detail-tab');
                return;
            }
            this.$router.push({ name: 'MNG_SalesReport001' });
        },
        mapDataFromApi(clientCd, responseData) {
            const header = responseData?.header || {};
            const schedules = responseData?.schedules || [];
            const visitReports = responseData?.visit_reports || [];
            const paging = responseData?.paging || {};
            const hasExistingReport = Boolean(header?.work_report_id);

            this.realData.work_report_id = hasExistingReport ? header.work_report_id : 0;
            this.realData.tab_no = hasExistingReport ? header.tab_no || 1 : 1;
            this.realData.md_name = header.md_name || this.realData.md_name || '';
            this.realData.mdcd = header.mdcd || header.department_cd || this.realData.mdcd || 0;
            this.realData.branch_cd = header.branch_cd || this.realData.branch_cd || 0;
            this.realData.branch_nm = header.branch_nm || this.realData.branch_nm || '';
            this.realData.company_name = hasExistingReport
                ? header.company_nm || header.company_name || this.realData.company_name || ''
                : this.realData.company_name || '';
            this.realData.client_cd = header.client_cd || clientCd || this.realData.client_cd || '';
            this.realData.client_nm = header.customer_name || this.realData.client_nm || '';
            this.realData.visit_date = hasExistingReport ? header.visit_date || '' : '';
            this.realData.report_date = hasExistingReport ? header.report_date || '' : '';
            // this.realData.order_no1 = header.order_no1 || header.sales_note || '';
            // if (Array.isArray(this.realData.places) && this.realData.places.length > 0) {
            //     this.realData.places[0].order_no1 = this.realData.order_no1;
            // }
            this.realData.report_items_contents1 = hasExistingReport ? header.report_items_contents1 || '' : '';
            this.realData.reporting_filename = hasExistingReport ? header.reporting_filename || '' : '';

            this.realData.schedules = (schedules || []).map((item, index) => ({
                staff_detail_no: item.staff_detail_no || 0,
                no: item.staff_detail_no || index + 1,
                start_date: item.start_date || '',
                name_person: item.staff_name || '',
                filename: item.filename || item.file_path || '',
                file_path: item.file_path || item.filename || '',
                file: '',
                notes: item.notes || item.remarks || ''
            }));
            if (this.realData.schedules.length === 0) {
                this.realData.schedules = [
                    { staff_detail_no: 0, no: '', start_date: '', name_person: '', filename: '', file_path: '', file: '', notes: '' }
                ];
            }

            this.realData.visit_reports = visitReports || [];

            this.paginationData.pageNo = parseInt(paging.page || 1);
            this.paginationData.pageSize = parseInt(paging.pageSize || 10);
            this.paginationData.totalRows = parseInt(paging.totalRows || 0);
            this.paginationData.msgNoData = this.paginationData.totalRows === 0 ? '該当するデータが存在しません。' : '';
        },
        referByRouteId(id, companyCd = '') {
            const clientCd = parseInt(id || 0);
            if (companyCd) {
                this.realData.company_cd = companyCd;
            }
            if (!this.realData.company_cd || !clientCd || !this.realData.branch_cd) {
                this.resetDetailBody();
                return;
            }
            repository
                .getData({
                    company_cd: this.realData.company_cd ?? this.$route?.params?.company_cd ?? '',
                    mdcd: this.realData.mdcd ?? 0,
                    client_cd: clientCd,
                    branch_cd: this.realData.branch_cd ?? 0,
                    page_no: this.paginationData.pageNo || 1,
                    page_size: this.paginationData.pageSize || 10
                })
                .then((res) => {
                    if (res?.data?.Code !== 200) {
                        this.showModalMessage({
                            type: MSG_TYPE.ERROR,
                            title: MSG_TITLE.E001,
                            content: res?.data?.Message || messages.E999,
                            cancelText: MSG_BUTTON.cancelText,
                            okText: MSG_BUTTON.okText
                        });
                        return;
                    }
                    this.mapDataFromApi(clientCd, res.data.Data || {});
                })
                .catch(() => {
                    this.showModalMessage({
                        type: MSG_TYPE.ERROR,
                        title: MSG_TITLE.E001,
                        content: messages.E999,
                        cancelText: MSG_BUTTON.cancelText,
                        okText: MSG_BUTTON.okText
                    });
                });
        },
        getData() {
            this.tryLoadByCurrentKey();
        },
        applyArrayItem(item) {
            if (!item || Object.keys(item).length === 0) return;

            if ((item.mode ?? 1) === 0) {
                this.$store.commit('MNG_SalesReport002/resetFormData', this.realData.type || '1');
                this.realData.md_name = item.md_name || item.supervising_department_name || item.department_name || '';
                this.realData.mdcd = item.mdcd || item.department_cd || 0;
                if (!this.isCompanyEditable) {
                    this.realData.company_cd = item.company_cd || this.loginCompanyCd || '';
                    this.realData.company_name = item.company_nm || item.company_name || '';
                }
                if (this.realData.company_cd && Number(this.realData.mdcd || 0) > 0) {
                    this.referAreaInfo(0, this.realData.mdcd);
                }
                return;
            }

            this.realData.company_cd = item.company_cd || this.realData.company_cd || '';
            this.realData.company_name = item.company_nm || item.company_name || this.realData.company_name || '';
            this.realData.md_name = item.md_name || item.supervising_department_name || item.department_name || this.realData.md_name || '';
            this.realData.mdcd = item.mdcd || item.department_cd || this.realData.mdcd || 0;
            this.realData.client_cd = item.trading_target || item.client_cd || item.customer_cd || '';
            this.realData.client_nm = item.trading_target_nm || item.client_name || item.customer_name || '';
            this.realData.branch_cd = item.branch_cd || item.branchCD || this.realData.branch_cd || 0;
            this.realData.branch_nm = item.branch_nm || this.realData.branch_nm || '';
            this.realData.visit_date = item.report_date || item.visit_date || '';
            this.realData.report_date = item.report_date || '';
            // this.realData.order_no1 = item.sales_considerations || item.sales_note || '';
            // if (Array.isArray(this.realData.places) && this.realData.places.length > 0) {
            //     this.realData.places[0].order_no1 = this.realData.order_no1;
            // }

            const clientCd = this.realData.client_cd || '';
            if (this.isValidRouteClientCd(clientCd)) {
                this.referByRouteId(clientCd, this.realData.company_cd || '');
            }
        },
        addNewSchedule() {
            this.realData.schedules.push({
                staff_detail_no: 0,
                no: '',
                start_date: '',
                name_person: '',
                filename: '',
                file_path: '',
                file: '',
                notes: ''
            });
        },
        addNewStaff() {
            this.localData.client_staff.push({
                id: this.localData.id,
                CompanyCD: this.localData.CompanyCD,
                StartDate: '',
                StaffName: '',
                FilePath: '',
                File: '',
                Remarks: ''
            });
        },
        renderNo(index) {
            return index + 1 < 10 ? '0' + (index + 1) : index + 1;
        },
        addNewPlace() {
            if (this.realData.places.length > 9) {
                return;
            }
            this.realData.places.push({
                business_matters: [],
                business_partners: [],
                intention_to_arrange: '',
                project_sharing: '',
                things_to_check: '',
                report_items_contents: '',
                business_matters_detail: ''
            });
        },
        renderTabNumber(number) {
            const map = {
                1: '①',
                2: '②',
                3: '③',
                4: '④',
                5: '⑤',
                6: '⑥',
                7: '⑦',
                8: '⑧',
                9: '⑨',
                10: '⑩'
            };
            return map[number];
        },
        // hideDetail() {
        //     this.$emit('emitHideDetail');
        // },
        deleteItemTable(index_no, item) {
            const isTabMode = this.checkTab != '0' && Array.isArray(this.localData?.client_staff);
            const list = isTabMode ? this.localData.client_staff : this.realData.schedules || [];
            if (!Array.isArray(list) || list.length === 0) return;
            if (list.length === 1) return;

            const hasData = isTabMode
                ? Boolean(item?.StartDate || item?.StaffName || item?.FilePath || item?.Remarks || item?.StaffDetailNo)
                : Boolean(item?.start_date || item?.name_person || item?.filename || item?.file_path || item?.notes || item?.remarks || item?.no);
            const removeRow = () => {
                list.splice(index_no, 1);
            };

            if (!hasData) {
                removeRow();
                return;
            }

            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (ok) removeRow();
                }
            });
        },
        updateBusinessCardTable(index_no) {
            if (this.realData.schedules.length == 1) return;
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: MSG_TITLE.C003,
                content: messages.C003,
                cancelText: 'いいえ',
                okText: 'はい',
                callback: (ok) => {
                    if (ok) {
                        if (this.realData.schedules.length > 1) {
                            this.realData.schedules.splice(index_no, 1);
                        }
                    }
                }
            });
        },
        changeType() {
            const keyData = {
                company_cd: this.realData.company_cd,
                company_name: this.realData.company_name,
                mdcd: this.realData.mdcd,
                md_name: this.realData.md_name,
                client_cd: this.realData.client_cd,
                client_nm: this.realData.client_nm,
                branch_cd: this.realData.branch_cd,
                branch_nm: this.realData.branch_nm
            };
            this.resetFormData(this.realData.type);
            Object.assign(this.realData, keyData);
        },
        isShow() {
            // this.type = mode;
            this.isShowWorkReport003 = true;
            // console.log('Row clicked:', this.realData.schedules[mode]);
        },
        openFile(id, index) {
            document.querySelector('#' + id + index).value = '';
            document.querySelector('#' + id + index).click();
        },
        async deleteFile(item) {
            const oldPath = item?.file_path || '';
            if (oldPath) {
                const formData = new FormData();
                formData.append('company_cd', this.realData.company_cd || this.user?.company_cd || '');
                formData.append('status', 12);
                formData.append('old_path', oldPath);
                try {
                    await repository.uploadFileToSharePath(formData);
                } catch (e) {
                    console.log(e);
                }
            }
            item.filename = '';
            item.file_path = '';
            item.file = '';
        },
        downloadScheduleFile(item) {
            const fileName = item?.filename || '';
            const filePath = item?.file_path || fileName;
            if (!fileName || !filePath) return;
            helpers.getFileToDownloadSys004({
                fileName: fileName,
                status: 12,
                company_cd: this.data.company_cd
            });
        },
        downloadStaffFile(item) {
            if (!item.StaffDetailNo || !item.FilePath) return;
            helpers.getFileToDownloadSys004({
                fileName: item.FilePath,
                status: 12,
                company_cd: this.localData.CompanyCD
            });
        },
        deleteFileReport() {
            this.realData.reporting_filename = '';
            this.realData.reporting_file = '';
        },
        async changeFile(event, item, index) {
            const file = event.target.files[0];
            if (!file) return;
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#business_card' + (index + 1)).value = '';
                return;
            }
            const isPdf = file.type === 'application/pdf';
            const isImage = typeof file.type === 'string' && file.type.startsWith('image/');
            if (!isPdf && !isImage) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: 'PDFまたは画像ファイル（JPG/PNGなど）を選択してください。',
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.filename = '';
                            item.file = '';
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.filename = '';
                            item.file = '';
                        }
                    }
                });
                return;
            }
            const oldPath = item?.file_path || '';
            const formData = new FormData();
            formData.append('company_cd', this.realData.company_cd || this.user?.company_cd || '');
            formData.append('status', 12);
            formData.append('file', file);
            if (oldPath) {
                formData.append('old_path', oldPath);
            }

            try {
                const res = await repository.uploadFileToSharePath(formData);
                if (res?.data?.Code === 200) {
                    item.filename = res?.data?.Data?.file_name || file.name;
                    item.file_path = res?.data?.Data?.file_path || '';
                    item.file = '';
                    return;
                }
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: res?.data?.Message || messages.E999,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
            } catch (e) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E999,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
            }
        },

        initArrow(col, key) {
            this.sort = {
                start_date: '',
                name_person: '',
                notes: ''
            };
            this.sort[col] = key;
        },
        // 担当開始日
        sortStartDate(key) {
            this.initArrow('startDate', key);
            this.sortData('startDate', key === 'asc');
        },

        //担当者名
        sortNamePerson(key) {
            this.initArrow('namePerson', key);
            this.sortData('namePerson', key === 'asc');
        },

        //備考
        sortNotes(key) {
            this.initArrow('Notes', key);
            this.sortData('Notes', key === 'asc');
        },
        sortData(key, ascending, isNumber = false, isDate = false) {
            const multiplier = ascending ? 1 : -1;
            this.realData.schedules.sort((a, b) => {
                let aVal = a[key];
                let bVal = b[key];
                console.log(aVal + ',' + bVal);
                if (aVal === bVal) return 0;
                if (aVal === null || aVal === '') return 1;
                if (bVal === null || bVal === '') return -1;

                let comparison = 0;
                if (isNumber) {
                    comparison = aVal < bVal ? -1 : 1;
                } else if (isDate) {
                    comparison = new Date(aVal) < new Date(bVal) ? -1 : 1;
                } else {
                    comparison = aVal.localeCompare(bVal, undefined, {
                        numeric: true,
                        sensitivity: 'base'
                    });
                }

                return comparison * multiplier;
            });
        },
        openDetail(value) {
            this.localMode = value;
            this.$emit('open');
        },
        changeCurrentPage(data) {
            // Main SalesReport002 screen (no localData): use API getData pagination.
            if (!this.localData || !this.localData.paginationData) {
                this.paginationData.pageNo = data.currentPage;
                this.paginationData.pageSize = data.perPage;
                const clientCd = this.realData.client_cd || '';
                if (this.isValidRouteClientCd(clientCd)) {
                    this.referByRouteId(clientCd, this.realData.company_cd || '');
                }
                return;
            }

            // Tab detail context: keep existing past-sales-record pagination behavior.
            this.localData.paginationData.pageNo = data.currentPage;
            this.localData.paginationData.pageSize = data.perPage;
            this.searchPastSalesReport({
                body: {
                    company_cd: this.localData.CompanyCD,
                    work_report_id: this.localData.WorkReportID,
                    client_cd: this.localData.ClientCD,
                    branch_cd: this.localData.BranchCD,
                    page_no: data.currentPage,
                    page_size: data.perPage
                },
                callback: (data) => {
                    this.localData.past_sales_records = data;
                }
            });
        },
        drafSubmit() {
            console.log('Draft submit');
        },
        focusElementById(id) {
            const element = this.$el?.querySelector(`#${id}`) || document.getElementById(id);
            if (!element) return false;

            const input = element.matches?.('input, textarea, select')
                ? element
                : element.querySelector?.('input:not([type="hidden"]), textarea, select');

            if (!input || input.disabled || input.readOnly) return false;
            if (input.type === 'file' || input.type === 'hidden') return false;

            input.focus();
            return true;
        },
        focusFirstEditableField() {
            const root = this.$el;
            if (!root) return;

            const candidates = Array.from(root.querySelectorAll('input, textarea, select'));
            const firstEditable = candidates.find((el) => {
                if (!el) return false;
                if (el.disabled || el.readOnly) return false;
                if (el.type === 'hidden' || el.type === 'file' || el.type === 'button' || el.type === 'submit') return false;
                return el.offsetParent !== null || el.getClientRects().length > 0;
            });

            if (firstEditable) {
                firstEditable.focus();
            }
        },
        focusFirstInvalidField() {
            const companyCd = String(this.realData?.company_cd || '').trim();
            if (this.isCompanyEditable && !this.isEditMode && !companyCd) {
                if (this.focusElementById('company_cd')) return;
            }
            if (!Number(this.realData?.mdcd || 0)) {
                if (this.focusElementById('mdcd')) return;
            }

            if (!String(this.realData?.client_cd || '').trim()) {
                if (this.focusElementById('client_cd')) return;
            }

            if (!String(this.realData?.branch_cd || '').trim()) {
                if (this.focusElementById('branch_cd')) return;
            }

            const schedules = this.realData?.schedules || [];
            for (let i = 0; i < schedules.length; i++) {
                const item = schedules[i] || {};
                const startDate = String(item.start_date || '').trim();
                const namePerson = String(item.name_person || '').trim();
                if (!startDate) {
                    if (this.focusElementById(`start_date${i}`)) return;
                }
                if (!namePerson) {
                    if (this.focusElementById(`name_person${i}`)) return;
                }
            }

            this.focusFirstEditableField();
        },
        hasInvalidScheduleRows() {
            return (this.realData.schedules || []).some((item) => {
                const startDate = item?.start_date ? String(item.start_date).trim() : '';
                const namePerson = item?.name_person ? String(item.name_person).trim() : '';
                return startDate === '' || namePerson === '';
            });
        },
        submit() {
            const companyCd = String(this.realData.company_cd || '').trim();
            const clientCd = this.realData.client_cd || '';
            const branchCd = String(this.realData.branch_cd || '').trim();
            if ((this.isCompanyEditable && !companyCd) || !clientCd || !branchCd || Number(this.realData.mdcd || 0) <= 0) {
                this.focusFirstInvalidField();
                return;
            }

            if (this.hasInvalidScheduleRows()) {
                this.focusFirstInvalidField();
                return;
            }

            const schedules = this.realData.schedules || [];
            const usedStaffDetailNos = schedules.map((item) => Number(item?.staff_detail_no || 0)).filter((no) => no > 0);
            let nextStaffDetailNo = usedStaffDetailNos.length > 0 ? Math.max(...usedStaffDetailNos) + 1 : 1;

            const details = schedules.map((item) => {
                let staffDetailNo = Number(item.staff_detail_no || 0);
                if (staffDetailNo <= 0) {
                    staffDetailNo = nextStaffDetailNo;
                    nextStaffDetailNo += 1;
                }
                return {
                    staff_detail_no: staffDetailNo,
                    start_date: item.start_date || '',
                    staff_name: item.name_person || '',
                    file_path: item.file_path || item.filename || '',
                    remarks: item.notes || ''
                };
            });

            const formData = new FormData();
            formData.append('company_cd', this.realData.company_cd ?? '');
            formData.append('mdcd', this.realData.mdcd || 0);
            formData.append('work_report_id', this.realData.work_report_id || 0);
            formData.append('tab_no', this.realData.tab_no || this.realData.index_type || this.tabId || 1);
            formData.append('client_cd', clientCd);
            formData.append('branch_cd', this.realData.branch_cd || 0);
            // formData.append('sales_note', salesNote);
            formData.append('report_items_contents1', this.realData.report_items_contents1 || '');
            formData.append('reporting_filename', this.realData.reporting_filename || '');
            formData.append('visit_date', this.realData.visit_date || '');
            formData.append('report_date', this.realData.report_date || '');
            formData.append('business_matters_json', JSON.stringify(this.realData.business_matters || []));
            formData.append('detail_json', JSON.stringify(details));
            if (this.realData.reporting_file && typeof this.realData.reporting_file !== 'string') {
                formData.append('reporting_file', this.realData.reporting_file);
            }

            (this.realData.schedules || []).forEach((item, index) => {
                if (item.file && typeof item.file !== 'string') {
                    formData.append(`detail_files[${index}]`, item.file);
                }
            });

            const isUpdate = (this.realData.schedules || []).some((item) => Number(item?.staff_detail_no || 0) > 0);
            this.showModalMessage({
                type: MSG_TYPE.CONFIRM,
                title: isUpdate ? MSG_TITLE.C002 : MSG_TITLE.C001,
                content: isUpdate ? messages.C002 : messages.C001,
                cancelText: MSG_BUTTON.cancelText,
                okText: MSG_BUTTON.okText,
                callback: (ok) => {
                    if (!ok) return;
                    repository
                        .storeSave(formData)
                        .then((res) => {
                            if (res.data.Code === 200) {
                                const newWorkReportId = res?.data?.Data?.work_report_id ?? 0;
                                if (newWorkReportId) {
                                    this.realData.work_report_id = newWorkReportId;
                                }
                                this.showModalMessage({
                                    type: MSG_TYPE.SUCCESS,
                                    title: isUpdate ? MSG_TITLE.S002 : MSG_TITLE.S001,
                                    content: isUpdate ? messages.S002 : messages.S001,
                                    cancelText: MSG_BUTTON.cancelText,
                                    okText: MSG_BUTTON.okText,
                                    callback: (okSuccess) => {
                                        if (okSuccess) {
                                            this.handleBack();
                                        }
                                    }
                                });
                                return;
                            }
                            this.showModalMessage({
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: res.data.Message || messages.E999,
                                cancelText: MSG_BUTTON.cancelText,
                                okText: MSG_BUTTON.okText
                            });
                        })
                        .catch(() => {
                            this.showModalMessage({
                                type: MSG_TYPE.ERROR,
                                title: MSG_TITLE.E001,
                                content: messages.E999,
                                cancelText: MSG_BUTTON.cancelText,
                                okText: MSG_BUTTON.okText
                            });
                        });
                }
            });
        },
        referClientInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchMst001Info({
                        company_cd: this.realData.company_cd ?? this.$route?.params?.company_cd ?? '',
                        customer_cd: value || 0,
                        pageNo: 1,
                        pageSize: 1,
                        callback: (response) => {
                            const result = response?.Data?.data?.[0];
                            if (result) {
                                this.realData.client_cd = result.customer_cd ?? '';
                                this.realData.client_nm = result.customer_name ?? '';
                                this.realData.mdcd = result.mdcd ?? result.department_cd ?? this.realData.mdcd ?? 0;
                                this.clearBranchInfo();
                                this.resetDetailBody();
                            } else {
                                this.realData.client_cd = '';
                                this.realData.client_nm = '';
                                this.realData.mdcd = 0;
                                this.clearBranchInfo();
                                this.resetDetailBody();
                            }
                            resolve();
                        },
                        onError: (error) => {
                            console.log(error);
                            reject(error);
                        }
                    });
                } else {
                    this.realData.client_cd = '';
                    this.realData.client_nm = '';
                    this.realData.mdcd = 0;
                    this.clearBranchInfo();
                    this.resetDetailBody();
                    resolve();
                }
            });
        },
        getClientName(data) {
            this.realData.client_nm = data;
            const selectedClientCd = String(this.realData.client_cd || '');
            if (selectedClientCd) {
                this.referClientInfo(0, selectedClientCd);
            }
        },
        getClientNameTab(data) {
            this.localData.ClientName = data;
            this.localData.BranchCD = '';
            this.localData.BranchName = '';
        },
        referClient(index, value) {
            if (!value) {
                this.localData.ClientCD = '';
                this.localData.ClientName = '';
                this.localData.BranchCD = '';
                this.localData.BranchName = '';
                return;
            }
            this.searchMst001Info({
                company_cd: this.localData.CompanyCD ?? '',
                customer_cd: value || 0,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.localData.ClientCD = result.customer_cd;
                        this.localData.ClientName = result.customer_name;
                    } else {
                        this.localData.ClientCD = '';
                        this.localData.ClientName = '';
                    }
                    this.localData.BranchCD = '';
                    this.localData.BranchName = '';
                }
            });
        },
        getBranch(data) {
            this.localData.BranchName = data;
        },
        referBranchCD(index, value) {
            if (!value) {
                this.localData.BranchCD = '';
                this.localData.BranchName = '';
                return;
            }
            this.searchMst002Info({
                company_cd: this.localData.CompanyCD ?? this.user?.company_cd ?? '',
                customer_cd: this.localData.ClientCD ?? 0,
                mdcd: this.localData.MDCD ?? 0,
                location_cd: value || 0,
                mode: 1,
                pageNo: 1,
                pageSize: 1,
                callback: (response) => {
                    const result = response?.Data?.data?.[0];
                    if (result) {
                        this.localData.BranchCD = result.location_cd;
                        this.localData.BranchName = result.location_name;
                    } else {
                        this.localData.BranchCD = '';
                        this.localData.BranchName = '';
                    }
                }
            });
        },
        referBranchInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (value) {
                    this.searchMst002Info({
                        company_cd: this.realData.company_cd ?? '',
                        customer_cd: this.realData.client_cd ?? '',
                        mdcd: this.realData.mdcd ?? 0,
                        location_cd: value || 0,
                        pageNo: 1,
                        pageSize: 1,
                        mode: 1,
                        callback: (response) => {
                            const result = response?.Data?.data?.[0];
                            if (result) {
                                this.realData.branch_cd = result.kyoten_cd ?? result.location_cd ?? '';
                                this.realData.branch_nm = result.kyoten_name ?? result.location_name ?? '';
                                this.tryLoadByCurrentKey();
                            } else {
                                this.clearBranchInfo();
                                this.resetDetailBody();
                            }
                            resolve();
                        },
                        onError: (error) => {
                            console.log(error);
                            reject(error);
                        }
                    });
                    return;
                }

                this.clearBranchInfo();
                this.resetDetailBody();
                resolve();
            });
        },
        referCompany(index, value) {
            const previousCompanyCd = String(this.realData.company_cd || '').trim();
            const clearDependentFields = () => {
                this.clearDepartmentInfo();
                this.realData.client_cd = '';
                this.realData.client_nm = '';
                this.clearBranchInfo();
                this.resetDetailBody();
            };

            if (value) {
                this.searchSystemInfo({
                    company_cd: value,
                    mode: 1,
                    callback: (response) => {
                        if (response.Data.data.length > 0) {
                            const result = response.Data.data[0];
                            this.realData.company_cd = result.company_cd;
                            this.realData.company_name = result.company_name;
                            if (previousCompanyCd && previousCompanyCd !== String(result.company_cd)) {
                                clearDependentFields();
                            } else {
                                this.tryLoadByCurrentKey();
                            }
                        } else {
                            this.realData.company_cd = '';
                            this.realData.company_name = '';
                            clearDependentFields();
                        }
                    }
                });
            } else {
                this.realData.company_cd = '';
                this.realData.company_name = '';
                clearDependentFields();
            }
        },
        getCompanyName(data) {
            this.realData.company_name = data;
        },
        referAreaInfo(index, value) {
            return new Promise((resolve, reject) => {
                if (!value) {
                    this.clearDepartmentInfo();
                    this.realData.client_cd = '';
                    this.realData.client_nm = '';
                    this.clearBranchInfo();
                    this.resetDetailBody();
                    resolve();
                    return;
                }
                this.searchAreaInfo({
                    company_cd: this.realData.company_cd ?? 0,
                    department_cd: value,
                    mode: 1,
                    callback: (response) => {
                        const result = response?.Data?.data?.[0];
                        if (result) {
                            this.realData.mdcd = result.department_cd || result.mdcd || 0;
                            this.realData.md_name = result.department_name || '';
                            this.tryLoadByCurrentKey();
                        } else {
                            this.clearDepartmentInfo();
                            this.realData.client_cd = '';
                            this.realData.client_nm = '';
                            this.clearBranchInfo();
                            this.resetDetailBody();
                        }
                        resolve();
                    },
                    onError: (error) => {
                        reject(error);
                    }
                });
            });
        },
        getAreaName(data) {
            this.realData.md_name = data;
        },
        getBranchName(data) {
            this.realData.branch_nm = data;
        },
        changeFileTabSale(event) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#reporting_tab_sale').value = '';
                return;
            }
            if (file.type != 'application/pdf') {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E004,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileTabSale();
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            this.deleteFileTabSale();
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            this.localData.FilePath = filename;
            this.localData.File = file;
        },
        deleteFileTabSale() {
            this.localData.FilePath = '';
            this.localData.File = '';
        },
        changeFileStaffCard(event, item, index) {
            const file = event.target.files[0];
            if (helpers.checkOverMaxFileSize(file)) {
                document.querySelector('#staff_business_card' + this.tabId + (index + 1)).value = '';
                return;
            }
            if (!file.type.startsWith('image/')) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: '画像ファイル（JPG/PNG）を選択してください。',
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.FilePath = '';
                            item.File = '';
                        }
                    }
                });
                return;
            }
            if (file.name.length > 200) {
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText,
                    callback: (ok) => {
                        if (ok) {
                            item.FilePath = '';
                            item.File = '';
                        }
                    }
                });
                return;
            }
            const filename = file.name;
            item.FilePath = filename;
            item.File = file;
        },
        deleteFileStaffCard(item) {
            item.FilePath = '';
            item.File = '';
        }
    }
};
export default MNG_SalesReport002;
</script>
